import { DateMonth } from '../components/month'
import {
  DateInfo,
  SelectedDaysDifficult,
} from '../components/month/model/model'

import { normalizeCalendarDate } from './date'

export interface InfoDayContent {
  dateInfo?: Partial<DateInfo[]>
  fullDate: string
  date: string
}

export type SelectedDates = 'previous' | 'future'

export interface ResultSelectedDates {
  type: SelectedDates
  isSelected?: boolean
}

export const InfoDay = (dateInfo?: DateInfo[]) => {
  let indexDay: number = 0

  const setContent = ({ fullDate, date }: InfoDayContent): DateMonth => {
    if (
      dateInfo?.[indexDay]?.date &&
      Date.parse(dateInfo?.[indexDay]?.date!) === Date.parse(fullDate)
    ) {
      const preparedDate: DateMonth = {
        day: date,
        color: dateInfo?.[indexDay]?.color,
        content: dateInfo?.[indexDay]?.content,
        isGreen: dateInfo?.[indexDay]?.isCheapest,
      }

      indexDay += 1

      return preparedDate
    }

    return {
      day: date,
    }
  }

  return setContent
}

export const DisabledDay = (
  activeDays: string[] = [],
  isExcursion?: boolean,
) => {
  let indexDay = 0

  return (fullDate: string) => {
    if (isExcursion && !activeDays?.length) {
      return true
    }

    const isActive =
      normalizeCalendarDate(fullDate) !==
      normalizeCalendarDate(activeDays[indexDay])
    if (!isActive) indexDay += 1
    return isActive
  }
}

export const SelectedDay = (
  indexCurrent: number,
  selectedDays?: SelectedDaysDifficult[],
) => {
  const selectedDaysArr = selectedDays?.[indexCurrent - 1]
    ? selectedDays?.[indexCurrent - 1]
    : undefined

  const getSelectedDateStatus = (fullDate: string): ResultSelectedDates => {
    const resultSelectedDates: Partial<ResultSelectedDates> = {}

    if (!selectedDaysArr) {
      selectedDays?.map((item) => {
        if (Date.parse(item.fullDate) === Date.parse(fullDate)) {
          resultSelectedDates.type = 'future'
          resultSelectedDates.isSelected = true
        }
      })[0]
    }

    if (
      selectedDaysArr?.fullDate &&
      Date.parse(selectedDaysArr?.fullDate) > Date.parse(fullDate)
    ) {
      resultSelectedDates.type = 'previous'
    }

    if (
      selectedDaysArr?.fullDate &&
      Date.parse(selectedDaysArr?.fullDate) < Date.parse(fullDate)
    ) {
      resultSelectedDates.type = 'future'
    }

    selectedDays?.map((item) => {
      if (Date.parse(item.fullDate) === Date.parse(fullDate)) {
        resultSelectedDates.isSelected = true
      }
    })[0]

    return resultSelectedDates as ResultSelectedDates
  }

  return getSelectedDateStatus
}
